export { default } from './CourseVariantSelector';
export type { Props, Props as CourseVariantSelectorProps } from './CourseVariantSelector';
